
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.773 7.966h-3.772V.014H6v7.952H2.228c-1.229 0-2.229 1-2.229 2.229v13.559c0 1.23 1 2.229 2.228 2.229h3.772v6H26v-6h3.773c1.229 0 2.229-1 2.229-2.23V10.194c0-1.229-1-2.229-2.229-2.229zM8 1.984h16.001v5.982H8V1.984zm16.001 28.001H8V18.973h16.001v11.012zm6.001-6.23c0 .128-.102.23-.229.23H26v-7.012H5.999v7.012H2.227a.23.23 0 01-.229-.23V10.196a.23.23 0 01.229-.23h27.546a.23.23 0 01.229.23zM26 11.982h-1a1 1 0 000 2h1a1 1 0 000-2z"}})])
          )
        }
      }
    